import { useEffect } from 'react'
import { Outlet, useNavigate } from 'react-router-dom'
import { useAuth } from '@/context/AuthContext'
import { Loader2 } from 'lucide-react'

export default function ProtectedLayout() {
  const { firebaseUser, loading } = useAuth()
  const navigate = useNavigate()

  useEffect(() => {
    if (!loading && !firebaseUser) {
      navigate('/login')
    }
  }, [firebaseUser, loading, navigate])

  if (loading) {
    return (
      <div className="flex min-h-[calc(100vh-8rem)] items-center justify-center">
        <Loader2 className="h-8 w-8 animate-spin text-indigo-600" />
      </div>
    )
  }

  if (!firebaseUser) {
    return null
  }

  return <Outlet />
}

